<template>
  <div>
    <form @submit.prevent="pressOk">
      <div class="row">
        <div class="col">
          <div class="form-group">
            <strong>Nombre</strong>
            <input type="text" v-model="cCenter.name" class="form-control no-limited" />
          </div>
          <div class="form-group">
            <strong>Descripción</strong>
            <input type="text" v-model="cCenter.description" class="form-control no-limited" />
          </div>
          <div class="form-group">
            <strong>Unidad De Negocio</strong>
            <v-select v-model="cCenter.businessUnitName" :options="businessUnits"></v-select> 
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <div class="form-group">
            <button class="btn btn-block btn-success">
              <i class="fa fa-save"></i>
              Guardar
            </button>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>
<script>
import { Post, Get } from "../../helper/axios.js";
import toastr from "toastr";
export default {
  data() {
    return {
      apiUrl: this.$store.getters.apiUrl,
      Post,
      Get
    };
  },
  props: ["cCenter","businessUnits"],
  created() {
     //this.getBusinessUnits();
  },

  methods: {
    pressOk() {
      if (this.cCenter) {
        var valid = true;
        var message = "Agregue o corrija los siguiente campos:<br>";
        if (!this.cCenter.name) {
          message = message + "* Nombre.<br>";
          valid = false;
        }
        if (!this.cCenter.businessUnitName) {
          message = message + "* Asignar Unidad de Negocio.<br>";
          valid = false;
        }
        if (valid) {
          this.cCenter.businessUnitId =  this.cCenter.businessUnitName.code
          this.cCenter.businessUnitName = this.cCenter.businessUnitName.label
          this.$emit("pressOk");
        } else {
          toastr.info(message);
        }
      }
    },          
    getBusinessUnits() {
          this.$store.commit("setLoading", true);
            this.Get(this.apiUrl+'v1/businessunits?' + this.urlQuery, (res) => {
                res.data.forEach(element => {
                    this.businessUnits.push(element.name)
                });
                this.$store.commit("setLoading", false);
            })
    },
  }
};
</script>


